import { createTheme } from '@mui/material';

export const invalidColor = 'color: #d32f2f';

export const customTheme = createTheme({
  typography: {
    fontFamily: 'Roboto',
  },
  palette: {
    primary: { main: '#118FF3', light: 'rgba(17, 143, 243, 0.08)', dark: '#0A5CAD' },
    secondary: { main: '#fc5d5d' },
    background: { default: '#F2F4F7' },
    error: { main: '#d32f2f' },
    action: { hover: '#eee' },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: `
      *::-webkit-scrollbar {
        width: 0.4em;
        height: 0.4em;
      }
      *::-webkit-scrollbar-track {
        background: #FAFAFA;
        border-radius: 8px;
      }
      *::-webkit-scrollbar-thumb {
        background-color: #C8C8C8;
        border-radius: 8px;
      }
      *::-webkit-scrollbar-thumb:hover {
        background: '#aaa',
      }
    `,
    },
    MuiTypography: {
      styleOverrides: {
        h1: {
          fontSize: '4rem',
          fontWeight: '400',
        },
        h2: {
          color: '#2B2B2BED',
          fontSize: '1.2rem',
          fontWeight: 'bold',
        },
        h3: {
          fontSize: '0.875rem',
          fontWeight: 500,
          lineHeight: 1.25,
        },
        h4: {
          fontSize: '1.8rem',
          fontWeight: 500,
          lineHeight: 1.25,
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        notchedOutline: {
          border: 0,
          borderBottom: '1px solid #C4C4C4',
          borderBottomLeftRadius: 0,
          borderBottomRightRadius: 0,
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          textTransform: 'none',
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          border: 'none',
          paddingLeft: 0,
        },
      },
    },
    MuiContainer: {
      styleOverrides: {
        root: {
          '@media (min-width:600px)': {
            paddingLeft: 0,
            paddingRight: 0,
          },
        },
      },
    },
  },
});
